import { createContext } from "react";
import { FinanceInventoryContextType } from "./finance-inventory-types";

export const FinanceInventoryContext = createContext<FinanceInventoryContextType | undefined>(undefined)
